import { Link } from 'react-router-dom';
import { useAccessLevel } from '../../hooks/useAccessLevel';
import { dataEntryPath } from '../../data/projects';

interface DataProjectHeaderProps {
  slug: string;
  title: string;
  description: string;
  hasEntry: boolean;
}

export default function DataProjectHeader({ slug, title, description, hasEntry }: DataProjectHeaderProps) {
  const { canEnterData } = useAccessLevel();

  return (
    <div className="mb-8">
      <Link to="/data" className="text-sm font-medium text-primary hover:text-primary-dark">
        Projects
      </Link>
      <div className="mt-2 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
          <p className="mt-2 text-gray-600 max-w-2xl">{description}</p>
        </div>
        {hasEntry && canEnterData && (
          <Link
            to={dataEntryPath(slug)}
            className="inline-flex items-center justify-center min-h-[44px] px-6 py-3 rounded-md font-medium border-2 border-primary text-primary hover:bg-primary hover:text-white transition-colors duration-150 focus-ring shrink-0"
          >
            Enter data
          </Link>
        )}
      </div>
    </div>
  );
}
